<template>
  <section>
    <div class="das-form-container">
      <div class="das-form-group">
        <div class="das-form-group-title">Thông tin người đặt</div>
        <div class="das-form-row">
          <div class="das-form-col col-6">
            <div class="">
              <div class="das-layout gap-10">
                <div style="width: 25%">
                  <div class="label das-label das-label--required">
                    {{ $t('field.title') }}
                  </div>
                  <el-select
                    v-model="bookerFormData.name"
                    :disabled="isBookerSelected"
                    :placeholder="$t('field.title')"
                  >
                    <el-option
                      v-for="item in titleOptions"
                      :key="`customer-title-${item.value}`"
                      :label="item.label"
                      :value="item.label"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div style="width: 75%">
                  <div>
                    <el-row :gutter="8">
                      <el-col :span="10">
                        <div class="label das-label">
                          {{ $t('field.firstName') }}
                        </div>
                        <input
                          v-model="bookerFormData.last_name"
                          :disabled="isBookerSelected"
                          type="text"
                          placeholder="Họ"
                        />
                      </el-col>
                      <el-col :span="14">
                        <div class="label das-label das-label--required">
                          {{ $t('field.lastName') }}
                        </div>
                        <div class="input-group">
                          <input
                            v-model="bookerFormData.first_name"
                            :disabled="isBookerSelected"
                            type="text"
                            placeholder="Tên"
                          />
                          <div class="input-group__append input-group-btn">
                            <button
                              :disabled="action != 'create'"
                              @click="onRemoveBooker"
                            >
                              <i class="el-icon-delete"></i>
                            </button>
                            <button
                              :disabled="action != 'create'"
                              @click="onOpenSelectBookerDialog"
                            >
                              <i class="el-icon-search"></i>
                            </button>
                          </div>
                        </div>
                      </el-col>
                    </el-row>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="das-form-col col-3">
            <div class="">
              <div class="label required">
                {{ $t('field.phoneNumber') }}
              </div>

              <el-row>
                <div class="input-group">
                  <div class="input-group">
                    <!-- <input
                      v-model="bookerFormData.phone"
                      v-numeric-only
                      type="number"
                      placeholder="Nhập số điện thoại"
                      required
                    /> -->
                    <tel-input
                      v-model="bookerFormData.phone"
                      v-numeric-only
                      :disabled="isBookerSelected"
                      default-country="VN"
                      :input-options="{
                        showDialCode: true,
                        placeholder: 'Số điện thoại'
                      }"
                      @country-changed="onCountryChanged"
                    />
                    <div class="input-group__append input-group-btn">
                      <button @click="onSearchDuplicateCustomer">
                        Kiểm tra
                      </button>
                    </div>
                  </div>
                </div>
              </el-row>
            </div>
          </div>
          <div class="das-form-col col-3">
            <div class="">
              <div class="label">
                {{ $t('field.email') }}
              </div>
              <validation-provider
                :name="$t('field.email')"
                rules="required|email"
              >
                <input
                  v-model="bookerFormData.email"
                  :disabled="isBookerSelected"
                  type="text"
                />
              </validation-provider>
            </div>
          </div>
        </div>
      </div>
      <hr />
      <!-- <div class="das-form-group">
        <div class="das-form-group-title">Thông tin đặt phòng</div>
        <div class="das-form-row">
          <div class="das-form-col col-4">
            <div class="">
              <div class="label">
                {{ $t('field.reminderDate') }}
              </div>
              <SingleCalendar v-model="formData.release_date" />
            </div>
          </div>
          <div class="das-form-col col-4">
            <div class="">
              <div class="label das-label das-label--required required">
                {{ $t('field.status') }}
              </div>
              <validation-provider
                :name="$t('field.status')"
                rules="required|number|min_value:0"
              >
                <el-select
                  v-model="additionalInfoFormData.booking_status"
                  placeholder="Vui lòng chọn"
                >
                  <el-option
                    v-for="item in statusOptions"
                    :key="`customer-title-${item.value}`"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </validation-provider>
            </div>
          </div>
          <div class="das-form-col col-4">
            <div class="">
              <div class="label">
                {{ $t('field.note') }}
              </div>
              <textarea
                id=""
                v-model="additionalInfoFormData.note"
                name=""
                style="width: 100%"
                rows="3"
              ></textarea>
            </div>
          </div>
        </div>
      </div>
      <hr /> -->
      <div class="das-form-group">
        <div class="das-form-group-title">Thống kê</div>
        <div class="das-form-row">
          <div class="das-form-col" style="width: 20%">
            <div class="">
              <div class="label">
                {{ $t('field.travelCompanyAndAgency') }}
              </div>
              <el-select
                v-model="additionalInfoFormData.agent_id"
                clearable
                filterable
                placeholder="Vui lòng chọn"
                @change="onChangeAgency"
              >
                <el-option
                  v-for="item in filteredAgencyOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="das-form-col" style="width: 20%">
            <div class="">
              <div class="label">
                {{ $t('field.agencyDebitAccount') }}
              </div>
              <el-select
                v-model="additionalInfoFormData.debit_account_id"
                :disabled="!additionalInfoFormData.agent_id"
                clearable
                filterable
                placeholder="Vui lòng chọn"
              >
                <el-option
                  v-for="item in debitAccountOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="das-form-col" style="width: 20%">
            <div class="">
              <div class="label">
                {{ 'Promotion' }}
              </div>
              <el-select
                v-model="additionalInfoFormData.promotion_id"
                collapse-tags
                filterable
                clearable
                :disabled="
                  additionalInfoFormData.voucher_codes &&
                  additionalInfoFormData.voucher_codes.length > 0
                "
                placeholder="Chọn promotion"
                @change="onPromotionChange"
              >
                <el-option
                  v-for="item in promotionOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="das-form-col" style="width: 20%">
            <div class="">
              <div class="label">
                {{ 'Voucher' }}
              </div>
              <el-row :gutter="4">
                <el-col :span="18">
                  <input
                    v-model="voucherInputValue"
                    type="text"
                    :placeholder="
                      additionalInfoFormData.promotion_id
                        ? 'Đã chọn promotion'
                        : 'Nhập mã voucher'
                    "
                    :disabled="!!additionalInfoFormData.promotion_id"
                    style="height: 32px"
                    @input="onVoucherInput"
                    @keyup.enter="addVoucher"
                  />
                </el-col>
                <el-col :span="6">
                  <el-button
                    type="primary"
                    size="small"
                    :disabled="
                      !voucherInputValue ||
                      !!additionalInfoFormData.promotion_id ||
                      !voucherInputValue.trim()
                    "
                    style="
                      width: 100%;
                      height: 32px;
                      font-size: 11px;
                      padding: 0;
                    "
                    @click="addVoucher"
                  >
                    <span>Thêm</span>
                  </el-button>
                </el-col>
              </el-row>

              <!-- Hiển thị danh sách voucher đã thêm -->
              <div
                v-if="
                  additionalInfoFormData.voucher_codes &&
                  additionalInfoFormData.voucher_codes.length > 0 &&
                  !additionalInfoFormData.promotion_id
                "
                class="voucher-tags-container"
              >
                <div class="voucher-tags-title">
                  Voucher đã thêm:
                  <el-button
                    type="success"
                    size="mini"
                    style="margin-left: 10px; font-size: 10px; padding: 2px 8px"
                    @click="checkAllVouchers"
                  >
                    <i
                      v-if="voucherStatus === 'checking'"
                      class="el-icon-loading"
                    ></i>
                    <i
                      v-else-if="voucherStatus === 'valid'"
                      class="el-icon-check"
                      style="color: #67c23a"
                    ></i>
                    <i
                      v-else-if="voucherStatus === 'invalid'"
                      class="el-icon-close"
                      style="color: #f56c6c"
                    ></i>
                    <span v-else>Kiểm tra tất cả</span>
                  </el-button>
                </div>
                <div class="voucher-tags">
                  <el-tag
                    v-for="(
                      voucher, index
                    ) in additionalInfoFormData.voucher_codes"
                    :key="index"
                    :class="getVoucherTagClass(voucher)"
                    closable
                    :title="voucher.message || ''"
                    @close="removeVoucher(index)"
                  >
                    {{ voucher.code }}
                  </el-tag>
                </div>
              </div>
            </div>
          </div>
          <div class="das-form-col" style="width: 20%">
            <div class="">
              <div class="label das-label das-label--required">
                {{ $t('field.source') }}
              </div>
              <select-with-search-table
                style="width: 100%"
                :rows="sourceOptions"
                :columns="columnsSource"
                :search-fields="['code', 'desc']"
                :dropdown-width="400"
                :is-remove-btn="true"
                index-field="id"
                :selected-index-field-value="additionalInfoFormData.source_id"
                :value="additionalInfoFormData.source_id"
                @selectionChanged="onChangeSource"
              >
                <template v-slot:value="{ selectedValue: selectedData }">
                  {{ selectedData?.desc }}
                </template>
              </select-with-search-table>
            </div>
          </div>
        </div>
      </div>
      <hr />
      <div class="das-form-group">
        <div class="das-form-group-title">Thông tin phòng</div>
        <div class="das-form-col col-6 flex align-center">
          <div style="height: fit-content; margin-top: auto">
            <button
              class="btn small primary"
              style="margin-bottom: 8px"
              @click="onOpenCreateBookingRoom"
            >
              Tạo đặt phòng
            </button>
          </div>
        </div>
        <BookingFormRoomTable
          ref="BookingFormRoomTable"
          :record-rows="formData.booking_room"
          @recordSelected="onBookingRoomSelected"
        ></BookingFormRoomTable>
      </div>
      <el-dialog
        :visible="isBookingRoomDialogOpened"
        title="Thông tin đặt phòng"
        width="80%"
        append-to-body
        @close="onCloseBookingRoomDialog"
      >
        <BookingRoomForm
          v-if="isBookingRoomDialogOpened"
          ref="BookingRoomForm"
          :action="bookingRoomFormAction"
          :record-data="bookingRoomFormData"
          :promotion-info="selectedPromotion"
          :voucher-info="additionalInfoFormData.voucher_codes"
          @surchargesUpdated="onSurchargesUpdated"
          @servicesUpdated="onServicesUpdated"
          @dailyPriceUpdated="onDailyPriceUpdated"
          @bookingDatesUpdated="onBookingDatesUpdated"
        ></BookingRoomForm>
        <span
          slot="footer"
          class="dialog-footer"
          style="display: flex; gap: 10px; justify-content: flex-end"
        >
          <button
            v-if="bookingRoomFormAction == 'create'"
            class="btn primary small"
            @click="onCreateBookingRoom"
          >
            Thêm
          </button>
          <button
            v-if="bookingRoomFormAction == 'edit'"
            class="btn primary small"
            @click="onUpdateBookingRoom"
          >
            Cập nhật
          </button>
          <button
            v-if="canDeleteBookingRoom"
            class="btn pink small outline"
            @click="onDeleteBookingRoom"
          >
            Xóa
          </button>
          <button
            class="btn primary small outline"
            @click="onCloseBookingRoomDialog"
          >
            Đóng
          </button>
        </span>
      </el-dialog>
      <hr />

      <div class="das-form-group">
        <div class="das-form-group-title mt-10">Ghi chú</div>
        <div class="das-form-row">
          <div class="das-form-col col-4">
            <div class="">
              <!-- <div class="label">
                {{ $t('field.note') }}
              </div> -->
              <textarea
                id=""
                v-model="additionalInfoFormData.note"
                :disabled="
                  action === 'edit' && !bookingRecord?.is_able_update_note
                "
                name=""
                style="width: 100%"
                rows="3"
                maxlength="100"
              ></textarea>
            </div>
          </div>
          <div class="das-form-col col-4">
            <div class="das-form-input">
              <div class="label">Trạng thái đặt phòng</div>
              <div class="child-w-80">
                <el-select v-model="additionalInfoFormData.booking_status">
                  <el-option :value="1" label="Definite" />
                  <el-option :value="2" label="Tentative" />
                </el-select>
              </div>
            </div>
            <div class="">
              <!-- <div class="label">
                {{ $t('field.note') }}
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      :visible.sync="isSelectBookerDialogOpened"
      title="Danh sách khách hàng"
      width="70%"
    >
      <CustomerTable
        ref="CustomerTable"
        @updateMasterRoom="onUpdateMasterRoom"
        @onCustomerChecked="onBookerChecked"
      ></CustomerTable>
      <span
        slot="footer"
        class="dialog-footer"
        style="display: flex; gap: 10px; justify-content: flex-end"
      >
        <button
          class="btn primary small"
          @click="() => onSelectBooker(checkedBooker)"
        >
          Chọn
        </button>
        <button
          class="btn primary small outline"
          @click="onCloseSelectBookerDialog"
        >
          Đóng
        </button>
      </span>
    </el-dialog>
    <el-dialog
      :visible.sync="isCustomerProfileDialogOpened"
      title="Thông tin khách hàng"
      @close="isCustomerProfileDialogOpened = false"
    >
      <CustomerInfoDialog
        :customer-record="duplicateCustomer"
      ></CustomerInfoDialog>
      <div slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="onSelectDuplicateCustomer"
          >
            Lựa chọn
          </button>
          <button
            class="btn primary small"
            @click="isCustomerProfileDialogOpened = false"
          >
            Đóng
          </button>
        </div>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import { createBookingDeposit } from '@/api/booking_service/deposit'
import BookingRoomForm from './BookingRoomForm.vue'
import CustomerTable from '@/components/resources/customer/CustomerTable.vue'
import SelectWithSearchTable from '@/components/inputs/SelectWithSearchTable.vue'
import BookingFormRoomTable from './BookingFormRoomTable.vue'
// import CalendarSelect from '@/components/CalendarSelect/CalendarSelect.vue'
import { getAgent, getDebitAccByAgent } from '@/api/reception/common'
import { getMarketSegmentApi } from '@/api/Statistics/marketSegment'
import { getSourceListApi } from '@/api/common/source'
import {
  getNewPromotionList,
  checkVoucherApi,
  checkPromotionApi
} from '@/api/booking_service/promotion'
import {
  insertBookingApi,
  // getBookingRoom,
  updateBookingRoom
} from '@/api/booking_service/booking'
import { updateBooking } from '@/api/booking_service/bookingGroup'
import { findDuplicateTraveller } from '@/api/configuration/profile/traveller'
import CustomerInfoDialog from '../customer/CustomerInfoDialog.vue'
import { notifyError, notifySuccess } from '@/utils/toast'
import { validEmail } from '@/utils/validate'
import { getListRoomLevelApi } from '@/api/Room/roomLevel'
export default {
  components: {
    SelectWithSearchTable,
    CustomerTable,
    CustomerInfoDialog,
    BookingRoomForm,
    // CalendarSelect,
    BookingFormRoomTable
  },
  props: {
    bookingRecord: null,
    totalBooking: {
      type: Number,
      default: 0
    },
    booker: {
      required: true
    },
    action: {
      required: true,
      default: 'create',
      validator: value => {
        return ['create', 'edit', 'view'].includes(value)
      }
    }
  },
  data() {
    return {
      countryObject: null,
      isHydrated: false,
      isCustomerProfileDialogOpened: false,
      duplicateCustomer: null,
      bookingId: null,

      checkedBooker: null,

      isSelectBookerDialogOpened: false,
      isBookingRoomDialogOpened: false,
      isBookingDepositDialogOpened: false,
      bookingRoomFormData: null,
      bookingRoomTableIndex: null,
      bookingRoomFormAction: 'create',
      columnsSource: [
        {
          headerName: 'Mã nguồn',
          field: 'code',
          tooltipField: 'code',
          minWidth: 100,
          maxWidth: 150
        },

        {
          headerName: 'Mô tả',
          field: 'desc',
          tooltipField: 'desc',
          flex: 1
        }
      ],

      bookerFormData: {
        countryObject: null,
        id: null,
        name: 'Mr',
        phone: null,
        email: null,
        first_name: null,
        last_name: null
      },

      additionalInfoFormData: {
        note: null,
        agent_id: null,
        market_seg_id: null,
        source_id: null,
        promotion_id: null,
        voucher_codes: [],
        pay_method: null,
        credit_card: null,
        credit_card_owner: null,
        expired_credit_card: null,
        booking_status: 1,
        debit_account_id: null
      },

      formData: {
        release_date: null,
        booking_room: []
      },

      titleOptions: [
        { label: 'Mr', value: '0' },
        { label: 'Ms', value: '1' }
      ],
      debitAccountOptions: [],
      agencyOptions: [],
      marketSegmentOptions: [],
      sourceOptions: [],
      paymentMethodOptions: [
        { value: 1, label: 'Thẻ tín dụng' },
        { value: 2, label: 'Chuyển khoản' },
        { value: 3, label: 'Tiền mặt' }
      ],
      statusOptions: [
        { label: 'Definite', value: 1 },
        { label: 'Tentative', value: 2 },
        { label: 'Waiting', value: 3 }
      ],
      roomLevelList: [],
      promotionOptions: [],
      voucherInputValue: '',
      selectedPromotion: null,
      voucherStatus: 'initial', // 'initial', 'checking', 'valid', 'invalid'
      isUpdatingFromPromotion: false // Flag để tránh vòng lặp khi cập nhật từ promotion
    }
  },
  computed: {
    bookingTotal() {
      let total = +this.totalBooking

      this.formData.booking_room.forEach(booking => {
        // Skip canceled rooms (status: 3 = CANCELED)
        if (booking.status === 3) {
          return
        }

        booking.num_of_free_card = this.roomLevelList?.find(
          item => item.id === booking.room_type_id
        )?.free_card_quantity

        const arriveHousr = this.$moment(booking.arrive_date)
        const departHousr = this.$moment(booking.depart_date)

        // Skip adding to booking total if booking has price_type Mien phi/Noi o
        if (booking.price_type) {
          return
        }

        if (booking.daily_price) {
          booking.daily_price.forEach(day => {
            let dayPrice = day.price
            if (day.amount_discount) {
              dayPrice -= day.amount_discount
            } else if (day.percent_discount) {
              dayPrice = Math.round(
                (dayPrice * (100 - day.percent_discount)) / 100
              )
            }
            if (booking.hour_stay) {
              if (
                this.$moment
                  .duration(departHousr.diff(arriveHousr))
                  .asHours() <= 3
              ) {
                dayPrice = 0.3 * dayPrice
              } else if (
                this.$moment
                  .duration(departHousr.diff(arriveHousr))
                  .asHours() <= 6
              ) {
                dayPrice = 0.5 * dayPrice
              }
            }
            total += dayPrice
          })
        }
        if (
          booking.sub_booking_group_services != null ||
          booking.sub_booking_group_services?.length > 0
        ) {
          booking.sub_booking_group_services.forEach(el => {
            const totalDate =
              this.$moment(el.service_end_date).diff(
                el.service_start_date,
                'days'
              ) + 1
            total += el.quantity * el.price * Math.max(totalDate, 1)
          })
        }
        if (
          booking.sub_booking_group_surcharges != null &&
          booking.sub_booking_group_surcharges?.length > 0
        ) {
          let surchargeSubTotal = 0
          booking.sub_booking_group_surcharges.forEach(el => {
            const totalDate = this.$moment(el.end_date).diff(
              el.start_date,
              'days'
            )
            const surchargeAmount = el.quantity * el.price * Math.max(totalDate, 1)
            surchargeSubTotal += surchargeAmount
          })
          total += surchargeSubTotal
        }
      })
      // this.$emit('updateTotal', total)

      return total
    },
    canDeleteBookingRoom() {
      return (
        this.bookingRoomTableIndex != null &&
        this.bookingRoomFormData?.id == null
      )
    },
    isBookerSelected() {
      return this.bookerFormData.id != null
    },
    filteredAgencyOptions() {
      if (
        this.additionalInfoFormData.source_id == null ||
        this.additionalInfoFormData.source_id === ''
      ) {
        return this.agencyOptions
      }
      return this.agencyOptions.filter(
        option => option.source_id === this.additionalInfoFormData.source_id
      )
    }
  },
  watch: {
    bookingTotal(value) {
      this.$emit('updateTotal', value)
    },
    booker: {
      handler() {
        this.bookerFormData.id = this.booker.id
        this.bookerFormData.name = this.booker.name
        this.bookerFormData.phone = this.booker.phone
        this.bookerFormData.email = this.booker.email
        this.bookerFormData.first_name = this.booker.first_name
        this.bookerFormData.last_name = this.booker.last_name
      },
      deep: true
    },
    'additionalInfoFormData.agent_id': {
      handler(value) {
        if (!this.isHydrated) {
          return
        }
        if (value) {
          this.additionalInfoFormData.debit_account_id = null
          this.getDebitAccountOptions()
          notifySuccess('getDebitAccountSuccess')
        }
      },
      immediate: true
    },
    'additionalInfoFormData.voucher_codes': {
      handler(newVouchers, oldVouchers) {
        // Reset trạng thái kiểm tra khi voucher list thay đổi
        if (
          newVouchers &&
          newVouchers.length !== (oldVouchers ? oldVouchers.length : 0)
        ) {
          this.voucherStatus = 'initial'
        }
      },
      deep: true
    },
    'formData.booking_room': {
      handler(newVal, oldVal) {
        // Chỉ kiểm tra promotion khi:
        // 1. Có promotion được chọn
        // 2. Có phòng trong danh sách
        // 3. Không phải lần đầu khởi tạo (tránh gọi API khi hydrate data)
        // 4. Không phải thay đổi từ việc cập nhật giá (tránh vòng lặp)
        if (
          this.additionalInfoFormData.promotion_id &&
          this.formData.booking_room.length > 0 &&
          this.isHydrated &&
          !this.isUpdatingFromPromotion
        ) {
          // Kiểm tra xem có thay đổi thực sự về cấu trúc phòng không
          const hasStructuralChange = this.hasBookingRoomStructuralChange(newVal, oldVal)
          if (hasStructuralChange) {
            this.checkPromotion()
          }
        }
      },
      deep: true
    },
    'bookerFormData.phone': {
      handler() {
        if (!this.isHydrated) return
        const val = this.bookerFormData?.phone
        const isEmpty = val == null || val === ''
        if (this.isValidPhone() || isEmpty) {
          this.getPromotionOptions()
        }
      }
    },
    'additionalInfoFormData.source_id': {
      handler() {
        if (!this.isHydrated) return
        const val = this.additionalInfoFormData?.source_id
        const isEmpty = val == null || val === ''
        if (this.isValidSourceId() || isEmpty) {
          this.getPromotionOptions()
        }
      }
    }
  },

  async created() {
    this.isHydrated = false
    if (this.bookingRecord != null) {
      this.additionalInfoFormData = this.bookingRecord.additional_info
      this.bookerFormData = this.bookingRecord.booker
      this.formData.booking_room = this.bookingRecord.booking_room
      this.formData.release_date = this.bookingRecord.release_date
    }

    // Đảm bảo voucher_codes luôn là array
    if (!this.additionalInfoFormData.voucher_codes) {
      this.additionalInfoFormData.voucher_codes = []
    }

    // Khởi tạo voucher codes từ vouchersApplied nếu có
    if (this.bookingRecord?.voucher_list && Array.isArray(this.bookingRecord.voucher_list) && this.bookingRecord.voucher_list.length > 0) {
      this.additionalInfoFormData.voucher_codes = this.bookingRecord.voucher_list.map(voucherCode => ({
        code: voucherCode,
        name: voucherCode,
        status: 'valid', // Mặc định là valid vì đã được áp dụng trước đó
        message: 'Voucher đã được áp dụng'
      }))
      this.voucherStatus = 'valid'
    }

    await Promise.all([
      this.getAgencyOptions(),
      this.getMarketSegmentOptions(),
      this.getSourceOptions(),
      this.getDebitAccountOptions(),
      this.getRoomLevelOptions()
    ])
    await this.getPromotionOptions()
    this.isHydrated = true
  },
  mounted() {
    setTimeout(() => {
      this.$emit('updateTotal', this.bookingTotal)
    }, 500)
  },
  beforeDestroy() {
    // Cleanup if needed
  },

  methods: {
    isValidPhone() {
      const rawPhone = this.bookerFormData?.phone
      if (rawPhone == null || rawPhone === '') return false

      // Normalize: remove dial code and spaces/non-digits
      let phone = String(rawPhone)
      const dialCode = this.bookerFormData?.countryObject?.dialCode
      if (dialCode) {
        phone = phone.replace('+' + dialCode, '')
      }
      phone = phone.replace(/\D/g, '')

      // Basic length rules consistent with validateBookerFormData
      if (phone.length < 9) return false
      if (phone.length > 50) return false
      return true
    },
    isValidSourceId() {
      const sid = this.additionalInfoFormData?.source_id
      if (sid == null || sid === '') return false
      // valid if exists in sourceOptions list
      return this.sourceOptions?.some(opt => opt.id === sid)
    },
    formatPhoneNumber(phone) {
      if (!phone) return ''

      // Loại bỏ tất cả ký tự không phải số nhưng giữ dấu "+" nếu ở đầu
      const hasPlusAtStart = phone.startsWith('+')
      const cleanPhone = phone.replace(/\D/g, '')

      // Thêm lại dấu "+" nếu ban đầu có
      return hasPlusAtStart ? '+' + cleanPhone : cleanPhone
    },
    onCountryChanged(countryObject) {
      this.bookerFormData.countryObject = countryObject
    },
    onUpdateMasterRoom(colName, params, value) {
      this.formData.booking_room[params.rowIndex] = value
    },
    onBookerChecked(customer) {
      this.checkedBooker = customer
    },
    onSelectBooker(booker) {
      this.bookerFormData.id = booker.id
      this.bookerFormData.name = booker.name
      this.bookerFormData.first_name = booker.first_name
      this.bookerFormData.last_name = booker.last_name
      this.bookerFormData.phone = booker.phone_number
      this.bookerFormData.email = booker.email

      this.isSelectBookerDialogOpened = false

      this.$emit('bookerSelected', this.bookerFormData)
    },
    onCloseSelectBookerDialog() {
      this.isSelectBookerDialogOpened = false
      this.checkedBooker = null
    },
    onRemoveBooker() {
      this.$emit('bookerRemoved', this.bookerFormData)
      this.bookerFormData.id = null
      this.bookerFormData.name = null
      this.bookerFormData.first_name = null
      this.bookerFormData.last_name = null
      this.bookerFormData.phone = null
      this.bookerFormData.email = null
    },
    onOpenSelectBookerDialog() {
      this.isSelectBookerDialogOpened = true
    },
    onOpenBookingDepositDialog() {
      this.isBookingDepositDialogOpened = true
      this.$refs.BookingFormDepositDialog.hydrateFormData()
    },
    onBookingRoomSelected(event) {
      this.bookingRoomFormData = event.data
      this.bookingRoomTableIndex = event.rowIndex
      this.onOpenUpdateBookingRoom()
    },
    onCloseBookingRoomDialog() {
      this.isBookingRoomDialogOpened = false
    },
    onSurchargesUpdated(payload) {
      // Sync dữ liệu phụ thu phí vào formData.booking_room ngay lập tức
      // để trigger tính toán lại bookingTotal
      if (this.bookingRoomTableIndex !== null && this.bookingRoomTableIndex !== undefined) {
        if (this.formData.booking_room && this.formData.booking_room[this.bookingRoomTableIndex]) {
          // Đảm bảo Vue reactivity bằng cách dùng $set
          this.$set(
            this.formData.booking_room[this.bookingRoomTableIndex],
            'sub_booking_group_surcharges',
            JSON.parse(JSON.stringify(payload))
          )
        }
      }
    },
    onServicesUpdated(payload) {
      // Sync dữ liệu dịch vụ đặc biệt vào formData.booking_room ngay lập tức
      // để trigger tính toán lại bookingTotal
      if (this.bookingRoomTableIndex !== null && this.bookingRoomTableIndex !== undefined) {
        if (this.formData.booking_room && this.formData.booking_room[this.bookingRoomTableIndex]) {
          // Đảm bảo Vue reactivity bằng cách dùng $set
          this.$set(
            this.formData.booking_room[this.bookingRoomTableIndex],
            'sub_booking_group_services',
            JSON.parse(JSON.stringify(payload))
          )
        }
      }
    },
    onDailyPriceUpdated(payload) {
      // Sync dữ liệu giá ngày vào formData.booking_room ngay lập tức
      // để trigger tính toán lại bookingTotal
      if (this.bookingRoomTableIndex !== null && this.bookingRoomTableIndex !== undefined) {
        if (this.formData.booking_room && this.formData.booking_room[this.bookingRoomTableIndex]) {
          // Đảm bảo Vue reactivity bằng cách dùng $set
          this.$set(
            this.formData.booking_room[this.bookingRoomTableIndex],
            'daily_price',
            JSON.parse(JSON.stringify(payload))
          )
        }
      }
    },
    onBookingDatesUpdated(payload) {
      // Sync dữ liệu ngày đến và ngày đi vào formData.booking_room ngay lập tức
      // để trigger tính toán lại bookingTotal
      if (this.bookingRoomTableIndex !== null && this.bookingRoomTableIndex !== undefined) {
        if (this.formData.booking_room && this.formData.booking_room[this.bookingRoomTableIndex]) {
          // Đảm bảo Vue reactivity bằng cách dùng $set
          this.$set(this.formData.booking_room[this.bookingRoomTableIndex], 'arrive_date', payload.arrive_date)
          this.$set(this.formData.booking_room[this.bookingRoomTableIndex], 'depart_date', payload.depart_date)
        }
      }
    },
    onCreateBookingRoom() {
      const error = this.$refs.BookingRoomForm.validateForm()

      if (error !== null) {
        notifyError(error, true)
        return
      }

      const bookingRoom = this.$refs.BookingRoomForm.dehydrateForm()
      if (this.formData.booking_room.length === 0) {
        bookingRoom.is_master = true
      }

      this.formData.booking_room.push(bookingRoom)
      this.isBookingRoomDialogOpened = false
    },
    async onUpdateBookingRoom() {
      const error = this.$refs.BookingRoomForm.validateForm()

      if (error !== null) {
        notifyError(error, true)
        return
      }
      let payload = this.$refs.BookingRoomForm.dehydrateForm()

      // Skip canceled rooms (status: 3 = CANCELED) - cannot update canceled rooms
      if (this.bookingRoomFormData.id && this.bookingRoomFormData.status !== 3) {
        if (
          !(await this.updateBookingRoom(this.bookingRoomFormData.id, payload))
        ) {
          this.isBookingRoomDialogOpened = false
          return
        }
      }

      // Update not filtered back to the table in tab
      payload = this.$refs.BookingRoomForm.dehydrateForm(false)

      // Đảm bảo Vue reactivity bằng cách tạo object mới
      this.$set(
        this.formData.booking_room,
        this.bookingRoomTableIndex,
        { ...this.formData.booking_room[this.bookingRoomTableIndex], ...payload }
      )

      this.onCloseBookingRoomDialog()
      this.$refs.BookingFormRoomTable.$refs.bookingRoomTable.gridOptions.api.refreshCells(
        {
          force: true
        }
      )
    },
    onDeleteBookingRoom() {
      this.formData.booking_room.splice(this.bookingRoomTableIndex, 1)
      this.isBookingRoomDialogOpened = false
    },
    deleteBookingRoom() {},
    async onOpenUpdateBookingRoom() {
      if (this.bookingRoomFormData?.id != null) {
        // const bookingRoom = await getBookingRoom(this.bookingRoomFormData?.id)
        //   .then(res => {
        //     return res.data
        //   })
        //   .catch(() => {
        //     this.$message({
        //       type: 'error',
        //       message: 'Đã có lỗi xảy ra'
        //     })
        //   })

        // if (bookingRoom == null) {
        //   return
        // }

        // this.bookingRoomFormData = bookingRoom
      }
      this.bookingRoomFormAction = 'edit'
      this.isBookingRoomDialogOpened = true
    },

    onOpenCreateBookingRoom() {
      this.bookingRoomFormData = null
      this.bookingRoomTableIndex = null
      this.bookingRoomFormAction = 'create'
      this.isBookingRoomDialogOpened = true
    },
    onDeleteBooker() {},
    onSearchBooker() {},
    onClickSaveBooking() {
      const additionalInfo =
        this.$refs.BookingFormAdditionalInfoTab.dehydrateForm()
      Object.assign(this.formData, additionalInfo)

      if (this.bookingRecord) {
        this.updateBooking()
      } else {
        this.createBooking()
      }
    },
    async updateBookingRoom(id, payload) {
      try {
        const res = await updateBookingRoom(id, payload)
        notifySuccess(res?.message)
        return true
      } catch (err) {
        notifyError(err?.response?.data?.message)
        return false
      }
    },
    async updateBooking() {
      await updateBooking(this.bookingId, this.formData)
        .then(response => {
          notifySuccess(response.message)
        })
        .catch(error => {
          notifyError(error.response?.data?.message)
        })
    },
    async createBooking() {
      await insertBookingApi(this.formData)
        .then(response => {
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${response.message}`)
          })
        })
        .then(() => {
          this.$router.push('/reservation/search_reservation')
        })
        .catch(error => {
          const message = error.response?.data?.message || 'successMsg.default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },
    onCloseBookingFormDepositDialog() {
      this.isBookingDepositDialogOpened = false
    },
    async onCreateDeposit() {
      // TODO: Extract submit logic from this form
      const payload =
        await this.$refs.BookingFormDepositDialog.dehydrateFormData()

      if (this.bookingRecord != null) {
        await createBookingDeposit(this.formData)
          .then(res => {
            this.$message({
              type: 'success',
              message: 'Đã đặt cọc thành công'
            })
          })
          .catch(err => {
            const message = err?.response?.data?.message
            this.$message({
              type: 'error',
              message: message ?? 'Đã có lỗi xảy ra'
            })
          })
      } else {
        // Submit deposit along with payload when create new booking
        this.formData.deposit = payload
        this.$message({
          type: 'success',
          message: 'Đã thêm đặt cọc'
        })
      }
      this.isBookingDepositDialogOpened = false
    },
    onNavigateBack() {
      this.$router.push('/reservation/search_reservation')
    },
    validateBookerFormData() {
      if (this.isBookerSelected) {
        return null
      }
      if (
        this.bookerFormData.first_name &&
        this.bookerFormData.first_name.length > 30
      ) {
        return this.$t('validation.maxLength', {
          field: 'tên',
          length: 30
        })
      }
      if (
        this.bookerFormData.last_name &&
        this.bookerFormData.last_name.length > 30
      ) {
        return this.$t('validation.maxLength', {
          field: 'họ',
          length: 30
        })
      }
      if (this.bookerFormData.email) {
        if (this.bookerFormData.email.length > 50) {
          return this.$t('validation.maxLength', { field: 'email', length: 50 })
        }
        if (!validEmail(this.bookerFormData.email)) {
          return this.$t('validation.email')
        }
      }

      let phone = this.bookerFormData.phone
      phone = phone.replace(
        '+' + this.bookerFormData.countryObject?.dialCode,
        ''
      )
      phone = phone.replace(' ', '')
      if (phone != null && phone !== '') {
        if (phone.length < 9) {
          return this.$t('validation.minLength', {
            field: 'số điện thoại',
            length: 9
          })
        } else if (phone.length > 50) {
          return this.$t('validation.maxLength', {
            field: 'số điện thoại',
            length: 50
          })
        }
      }

      if (
        this.bookerFormData.email != null &&
        this.bookerFormData.email !== ''
      ) {
        if (!validEmail(this.bookerFormData.email)) {
          return this.$t('validation.email')
        }
      }
    },
    hydrateBookerFormData(data) {
      this.bookerFormData.id = data.id
      this.bookerFormData.last_name = data.last_name
      this.bookerFormData.first_name = data.first_name
      this.bookerFormData.phone = data.phone
      this.bookerFormData.email = data.email
    },
    hydrateFormData(data) {
      Object.assign(this.formData, data)
    },
    validateAdditionalInfoForm() {
      // if (this.additionalInfoFormData.booking_status == null) {
      //   return this.$t('validation.required', { field: 'trạng thái đặt phòng' })
      // }
      return null
    },
    dehydrateAdditionalInfoForm() {
      const payload = {
        agent_id: this.additionalInfoFormData.agent_id,
        note: this.additionalInfoFormData.note,
        source_id: this.additionalInfoFormData.source_id,
        promotion_id: this.additionalInfoFormData.promotion_id,
        voucher_codes: this.additionalInfoFormData.voucher_codes,
        booking_status: this.additionalInfoFormData.booking_status,
        debit_account_id: this.additionalInfoFormData.debit_account_id,
        market_seg_id: this.additionalInfoFormData.market_seg_id,
        pay_method: this.additionalInfoFormData.pay_method,
        credit_card: this.additionalInfoFormData.credit_card,
        expired_credit_card: this.additionalInfoFormData.expired_credit_card,
        credit_card_owner: this.additionalInfoFormData.credit_card_owner
      }
      return payload
    },
    dehydrateFormData() {
      const payload = JSON.parse(JSON.stringify(this.formData))
      return payload
    },
    async getDebitAccountOptions() {
      if (this.additionalInfoFormData.agent_id == null) {
        this.debitAccountOptions = []
        return
      }
      await getDebitAccByAgent({
        agentId: this.additionalInfoFormData.agent_id
      })
        .then(res => {
          this.debitAccountOptions = res.data
          if (!this.isHydrated) {
            return
          } else {
            this.additionalInfoFormData.debit_account_id =
              this.debitAccountOptions.length > 0
                ? this.debitAccountOptions[0].id
                : null
          }
        })
        .catch(err => {
          notifyError(err?.response?.data?.message)
        })
    },
    async getMarketSegmentOptions() {
      await getMarketSegmentApi({
        isActive: 1
      }).then(response => {
        this.marketSegmentOptions = response.data
      })
    },
    async getSourceOptions() {
      await getSourceListApi({
        isActive: 1
      }).then(response => {
        this.sourceOptions = response.data
      })
    },
    onChangeSource(value) {
      this.additionalInfoFormData.source_id = value?.id
      this.additionalInfoFormData.agent_id = null
      this.additionalInfoFormData.debit_account_id = null
    },
    async getAgencyOptions() {
      await getAgent().then(response => {
        this.agencyOptions = response.data
      })
    },
    onChangeAgency(id) {
      if (!this.isHydrated) {
        return
      }
      const selectedAgency = this.agencyOptions.find(e => e.id === id)
      if (selectedAgency == null) {
        return
      }
      // this.additionalInfoFormData.debit_account_id = selectedAgency?.

      this.additionalInfoFormData.market_seg_id = selectedAgency?.market_seg_id
      this.additionalInfoFormData.source_id = selectedAgency?.source_id
      this.$emit('agencySelected', id)
    },
    onRemoveCustomerFromBooking(customerId) {
      const travellerIndex = this.formData.booking_traveller.find(
        traveller => traveller.id === customerId
      )
      if (travellerIndex !== -1) {
        this.formData.booking_traveller.splice(travellerIndex, 1)
      }
    },
    onAddCustomerToBooking(customer) {
      const existingCustomer = this.formData.booking_traveller.find(
        bookingCustomer => bookingCustomer.traveller_id === customer.id
      )
      if (existingCustomer) {
        this.$message({
          type: 'error',
          message: 'Khách hàng đã nằm trong danh sách'
        })
        return
      }

      const shouldBeMaster = this.formData.booking_traveller.length === 0
      this.formData.booking_traveller.push({
        traveller_id: customer.id,
        first_name: customer.first_name,
        last_name: customer.last_name,
        is_master: shouldBeMaster,
        note: null
      })
    },
    async getRoomLevelOptions() {
      const data = await getListRoomLevelApi()
      this.roomLevelList = data?.data || []
    },
    async getPromotionOptions() {
      const today = this.$moment().format('YYYY-MM-DD')

      const validPhone = this.isValidPhone()
      const validSource = this.isValidSourceId()

      // Determine promotionType based on VALID phone/source_id
      let promotionType = 0 // default
      if (validPhone && validSource) {
        promotionType = 3
      } else if (validPhone) {
        promotionType = 1
      } else if (validSource) {
        promotionType = 2
      }

      await getNewPromotionList({
        isActive: 0,
        dateFrom: today,
        dateTo: today,
        applyType: 1,
        promotionType: promotionType
      }).then(response => {
        this.promotionOptions = response.data
      })
    },
    async findDuplicateTraveller(phone, number) {
      await findDuplicateTraveller(null, phone, number)
        .then(response => {
          if (response?.data == null) {
            notifyError('customerNotFound')
            return
          }
          this.duplicateCustomer = response?.data
          this.isCustomerProfileDialogOpened = true
        })
        .catch(() => {
          notifyError('customerNotFound')
        })
    },
    onSelectDuplicateCustomer() {
      this.onSelectBooker(this.duplicateCustomer)
      this.isCustomerProfileDialogOpened = false
    },
    onPhoneCountryChange(param) {
      this.bookerFormData.phone = param.dialCode
    },
    async onSearchDuplicateCustomer() {
      if (
        this.bookerFormData.first_name == null ||
        this.bookerFormData.phone == null ||
        this.bookerFormData.id != null
      ) {
        return
      }
      await this.findDuplicateTraveller(
        this.bookerFormData.first_name,
        this.bookerFormData.phone
      )
    },
    async onPromotionChange(value) {
      if (value) {
        this.additionalInfoFormData.promotion_id = value
        this.selectedPromotion = this.promotionOptions.find(p => p.id === value)
        this.voucherInputValue = ''
        this.additionalInfoFormData.voucher_codes = []

        // Tự động kiểm tra promotion khi chọn
        await this.checkPromotion()
      } else {
        this.selectedPromotion = null
        this.additionalInfoFormData.voucher_codes = []
        this.voucherInputValue = ''
        this.voucherStatus = 'initial'

        // Cập nhật lại giá phòng khi bỏ promotion
        this.$emit('promotionSelected', null)
        this.updateRoomPricesAfterPromotionRemoval()
      }
    },
    onVoucherInput(event) {
      this.voucherInputValue = event.target.value
      if (this.voucherInputValue && this.voucherInputValue.trim()) {
        this.additionalInfoFormData.promotion_id = null
        this.selectedPromotion = null
        this.voucherStatus = 'initial'

        // Cập nhật lại giá phòng khi bỏ promotion để nhập voucher
        this.updateRoomPricesAfterPromotionRemoval()
      }
    },

    addVoucher() {
      if (!this.voucherInputValue || !this.voucherInputValue.trim()) {
        this.$message.warning('Vui lòng nhập mã voucher.')
        return
      }

      if (this.additionalInfoFormData.promotion_id) {
        this.$message.warning('Bạn đã chọn promotion, không thể thêm voucher.')
        return
      }

      // Đảm bảo voucher_codes là array
      if (!this.additionalInfoFormData.voucher_codes) {
        this.additionalInfoFormData.voucher_codes = []
      }

      const voucherCode = this.voucherInputValue.trim()

      // Check for duplicates (case-insensitive)
      const existingVoucher = this.additionalInfoFormData.voucher_codes.find(
        v => v.code.toLowerCase() === voucherCode.toLowerCase()
      )

      if (existingVoucher) {
        this.$message.warning('Voucher đã tồn tại trong danh sách.')
        return
      }

      // Thêm voucher vào list ngay lập tức
      this.additionalInfoFormData.voucher_codes.push({
        code: voucherCode,
        name: voucherCode,
        status: 'unchecked', // 'unchecked', 'valid', 'invalid'
        message: null // Message từ API response
      })
      this.voucherInputValue = ''
      this.$emit('voucherAdded', this.additionalInfoFormData.voucher_codes)
      this.$message.success('Đã thêm voucher vào danh sách.')
    },

    async checkAllVouchers() {
      if (
        !this.formData.booking_room ||
        this.formData.booking_room.length === 0
      ) {
        this.$message.warning('Vui lòng chọn phòng trước khi kiểm tra.')
        return
      }
      if (
        !this.additionalInfoFormData.voucher_codes ||
        this.additionalInfoFormData.voucher_codes.length === 0
      ) {
        this.$message.warning('Không có voucher nào để kiểm tra.')
        return
      }

      this.voucherStatus = 'checking'
      try {
        // Chuẩn bị dữ liệu cho API
        const voucherCodes = this.additionalInfoFormData.voucher_codes.map(
          v => v.code
        )

        // Tạo day_list từ arrive_date đến depart_date
        const dayList = []
        const allDates = new Set()

        // Thu thập tất cả các ngày từ arrive_date đến depart_date của các phòng
        this.formData.booking_room.forEach(room => {
          const arriveDate = this.$moment(room.arrive_date)
          const departDate = this.$moment(room.depart_date)

          const currentDate = arriveDate.clone()
          while (currentDate.isBefore(departDate)) {
            allDates.add(currentDate.format('YYYY-MM-DD'))
            currentDate.add(1, 'day')
          }
        })

        // Tạo day_list với mỗi ngày và danh sách phòng tương ứng
        Array.from(allDates)
          .sort()
          .forEach(date => {
            // Sử dụng Map để nhóm phòng theo room_type_id và tính tổng quantity
            const roomMap = new Map()

            this.formData.booking_room.forEach(room => {
              const arriveDate = this.$moment(room.arrive_date)
              const departDate = this.$moment(room.depart_date)
              const currentDate = this.$moment(date)

              // Kiểm tra xem ngày hiện tại có nằm trong khoảng thời gian của phòng này không (chỉ so sánh ngày/tháng/năm)
              if (
                currentDate.startOf('day').isSameOrAfter(arriveDate.startOf('day')) &&
                currentDate.startOf('day').isBefore(departDate.startOf('day'))
              ) {
                const roomTypeId = room.room_type_id || 0

                // Tìm giá của ngày này trong daily_price
                const dayPrice = room.daily_price?.find(
                  day => this.$moment(day.date).format('YYYY-MM-DD') === date
                )
                const price = dayPrice?.price || 0

                // Nếu room_type_id đã tồn tại trong Map, tăng quantity
                if (roomMap.has(roomTypeId)) {
                  const existingRoom = roomMap.get(roomTypeId)
                  existingRoom.quantity += 1
                  // Có thể tính giá trung bình nếu cần
                  // existingRoom.price = (existingRoom.price + price) / 2
                } else {
                  // Thêm phòng mới vào Map
                  roomMap.set(roomTypeId, {
                    room_type_id: roomTypeId,
                    price: price,
                    quantity: 1
                  })
                }
              }
            })

            // Chuyển Map thành array cho room_list
            const roomList = Array.from(roomMap.values())

            if (roomList.length > 0) {
              dayList.push({
                date: date,
                room_list: roomList
              })
            }
          })

        // TODO: Thay thế bằng API call thực tế
        const response = await checkVoucherApi({
          voucher_list: voucherCodes,
          day_list: dayList
        })

        // Cập nhật trạng thái từng voucher dựa trên kết quả API
        this.additionalInfoFormData.voucher_codes.forEach(voucher => {
          if (response.data.voucher_applied.includes(voucher.code)) {
            voucher.status = 'valid'
            voucher.message = 'Voucher đã được áp dụng thành công'
          } else if (response.data.voucher_not_valid.includes(voucher.code)) {
            voucher.status = 'invalid'
            voucher.message = 'Voucher không hợp lệ hoặc đã hết hạn'
          } else {
            voucher.status = 'unchecked'
            voucher.message = 'Voucher chưa được kiểm tra'
          }
        })

        // Cập nhật giá phòng từ response nếu có voucher được áp dụng
        if (response.data.day_list) {
          this.updateRoomPricesFromResponse(response.data.day_list)
        }

        // Kiểm tra xem có voucher nào không hợp lệ không
        const hasInvalidVouchers = response.data.voucher_not_valid.length > 0
        const hasAppliedVouchers = response.data.voucher_applied.length > 0

        if (hasInvalidVouchers) {
          this.$message.warning(
            'Một số voucher không hợp lệ. Vui lòng kiểm tra danh sách.'
          )
          this.voucherStatus = 'invalid'
        } else if (hasAppliedVouchers) {
          this.$message.success('Tất cả voucher đều hợp lệ!')
          this.voucherStatus = 'valid'
          // Emit event để cập nhật voucher_list trong parent component
          this.$emit('vouchersApplied', response.data.voucher_applied)
        } else {
          this.voucherStatus = 'initial'
        }
      } catch (error) {
        console.error('Lỗi khi kiểm tra voucher:', error)
        const errorMessage = error.response?.data?.message || error.response?.data?.error || error.message || 'Có lỗi xảy ra khi kiểm tra voucher.'
        let displayMessage = ''
        switch (errorMessage) {
          case 'vouchersCannotBeUsedTogether':
            displayMessage = 'Các voucher này không được áp dụng đồng thời'
            break
          case 'voucherNotApplicableForRoomType':
            displayMessage = 'Voucher không được áp dụng cho loại phòng này'
            break
          default:
            displayMessage = errorMessage
        }
        this.$message.error(displayMessage)
        this.voucherStatus = 'invalid'
      }
    },

    async checkPromotion() {
      if (
        !this.formData.booking_room ||
        this.formData.booking_room.length === 0
      ) {
        this.$message.warning(
          'Vui lòng chọn phòng trước khi kiểm tra promotion.'
        )
        return
      }
      if (!this.additionalInfoFormData.promotion_id) {
        this.$message.warning('Không có promotion nào để kiểm tra.')
        return
      }

      // if (!this.bookerFormData.phone || this.bookerFormData.phone.replace(/\D/g, '').length < 9) {
      //   this.$message.warning('Vui lòng nhập số điện thoại.')
      //   return
      // }
      //
      // if (!this.additionalInfoFormData.source_id) {
      //   this.$message.warning('Vui lòng chọn công ty, đại lý du lịch.')
      //   return
      // }
      this.voucherStatus = 'checking'
      try {
        // Tạo day_list từ arrive_date đến depart_date
        const dayList = []
        const allDates = new Set()

        // Thu thập tất cả các ngày từ arrive_date đến depart_date của các phòng
        this.formData.booking_room.forEach(room => {
          const arriveDate = this.$moment(room.arrive_date)
          const departDate = this.$moment(room.depart_date)

          const currentDate = arriveDate.clone()
          while (currentDate.isBefore(departDate)) {
            allDates.add(currentDate.format('YYYY-MM-DD'))
            currentDate.add(1, 'day')
          }
        })

        // Tạo day_list với mỗi ngày và danh sách phòng tương ứng
        Array.from(allDates)
          .sort()
          .forEach(date => {
            const roomMap = new Map()
            this.formData.booking_room.forEach(room => {
              const arriveDate = this.$moment(room.arrive_date)
              const departDate = this.$moment(room.depart_date)
              const currentDate = this.$moment(date)

              // Kiểm tra xem ngày hiện tại có nằm trong khoảng thời gian của phòng này không
              if (
                currentDate.startOf('day').isSameOrAfter(arriveDate.startOf('day')) &&
                currentDate.startOf('day').isBefore(departDate.startOf('day'))
              ) {
                const roomTypeId = room.room_type_id || 0
                // Tìm giá của ngày này trong daily_price
                const dayPrice = room.daily_price?.find(
                  day => this.$moment(day.date).format('YYYY-MM-DD') === date
                )
                const price = dayPrice?.price || 0

                if (roomMap.has(roomTypeId)) {
                  const existingRoom = roomMap.get(roomTypeId)
                  existingRoom.quantity += 1
                  // Có thể tính giá trung bình nếu cần
                  // existingRoom.price = (existingRoom.price + price) / 2
                } else {
                  // Thêm phòng mới vào Map
                  roomMap.set(roomTypeId, {
                    room_type_id: roomTypeId,
                    price: price,
                    quantity: 1
                  })
                }
              }
            })

            const roomList = Array.from(roomMap.values())

            if (roomList.length > 0) {
              dayList.push({
                date: date,
                room_list: roomList
              })
            }
          })

        const response = await checkPromotionApi({
          promotion_id: this.additionalInfoFormData.promotion_id,
          day_list: dayList,
          info_guest: {
            phone: this.formatPhoneNumber(this.bookerFormData.phone),
            source_id: this.additionalInfoFormData.source_id
          }
        })

        // Cập nhật trạng thái promotion dựa trên kết quả API
        if (
          response.data.promotion_applied &&
          response.data.promotion_applied.length > 0
        ) {
          this.voucherStatus = 'valid'
          this.$message.success('Promotion đã được áp dụng thành công!')
        } else if (
          response.data.promotion_not_valid &&
          response.data.promotion_not_valid.length > 0
        ) {
          this.voucherStatus = 'invalid'
          this.$message.warning('Promotion không hợp lệ hoặc đã hết hạn.')
        } else {
          this.voucherStatus = 'initial'
          this.$message.warning('Promotion chưa được kiểm tra.')
        }

        if (response.data.promotion_applied &&
          response.data.promotion_applied.length > 0) {
          this.$emit('promotionSelected', this.additionalInfoFormData.promotion_id)
        } else {
          this.$emit('promotionSelected', null)
        }

        // Cập nhật giá phòng từ response nếu có promotion được áp dụng
        if (response.data.day_list) {
          this.updateRoomPricesFromResponse(response.data.day_list)
        }
      } catch (error) {
        console.error('Lỗi khi kiểm tra promotion:', error)
        this.$message.error('Có lỗi xảy ra khi kiểm tra promotion.')
        this.voucherStatus = 'invalid'
      }
    },

    removeVoucher(index) {
      if (!this.additionalInfoFormData.voucher_codes) {
        return
      }

      // Lưu voucher bị xóa để có thể reset giá
      const removedVoucher = this.additionalInfoFormData.voucher_codes[index]

      // Xóa voucher khỏi danh sách
      this.additionalInfoFormData.voucher_codes.splice(index, 1)

      // Reset trạng thái voucher nếu không còn voucher nào
      if (this.additionalInfoFormData.voucher_codes.length === 0) {
        this.voucherStatus = 'initial'
      } else {
        // Nếu còn voucher, reset trạng thái về initial để có thể kiểm tra lại
        this.voucherStatus = 'initial'
      }

      // Cập nhật lại giá phòng (xóa giảm giá từ voucher đã xóa)
      this.updateRoomPricesAfterVoucherRemoval()

      // Force update UI để đảm bảo voucher tags được cập nhật
      this.$forceUpdate()

      // Emit event
      this.$emit('voucherRemoved', removedVoucher)

      // Hiển thị thông báo
      this.$message.success(`Đã xóa voucher: ${removedVoucher.code}`)
    },

    getVoucherTagClass(voucher) {
      switch (voucher.status) {
        case 'valid':
          return 'voucher-tag voucher-tag--valid'
        case 'invalid':
          return 'voucher-tag voucher-tag--invalid'
        default:
          return 'voucher-tag voucher-tag--unchecked'
      }
    },

    updateRoomPricesFromResponse(dayList) {
      // Set flag để tránh vòng lặp
      this.isUpdatingFromPromotion = true

      // Duyệt qua từng ngày trong response
      dayList.forEach(responseDay => {
        const responseDate = responseDay.date

        // Tìm phòng tương ứng trong formData.booking_room
        this.formData.booking_room.forEach(room => {
          const departDate = this.$moment(room.depart_date)
          const currentDate = this.$moment(responseDate)

          // Kiểm tra xem ngày response có nằm trong khoảng thời gian của phòng này không
          if (
            currentDate.isBefore(departDate)
          ) {
            // Tìm daily_price tương ứng với ngày này
            const dayPriceIndex = room.daily_price?.findIndex(
              day =>
                this.$moment(day.date).format('YYYY-MM-DD') === responseDate
            )

            if (dayPriceIndex !== -1 && room.daily_price[dayPriceIndex]) {
              // Tìm room_type tương ứng trong response
              const responseRoom = responseDay.room_list.find(
                r => r.room_type_id === room.room_type_id
              )

              if (responseRoom) {
                // Cập nhật giá, chỉ thay thế nếu field trong response không null
                if (
                  responseRoom.price !== null &&
                  responseRoom.price !== undefined
                ) {
                  room.daily_price[dayPriceIndex].price = responseRoom.price
                }

                if (
                  responseRoom.room_type_name !== null &&
                  responseRoom.room_type_name !== undefined
                ) {
                  // Có thể cần cập nhật room_type_name nếu có field này trong daily_price
                  // room.daily_price[dayPriceIndex].room_type_name = responseRoom.room_type_name
                }

                if (
                  responseRoom.discount !== null &&
                  responseRoom.discount !== undefined
                ) {
                  // Nếu discount = 0, để trống thông tin giảm giá
                  if (responseRoom.discount === 0) {
                    room.daily_price[dayPriceIndex].amount_discount = null
                    room.daily_price[dayPriceIndex].percent_discount = null
                    room.daily_price[dayPriceIndex].discount_reason = null
                  } else {
                    // Nếu có discount, cập nhật thông tin
                    room.daily_price[dayPriceIndex].amount_discount =
                      responseRoom.discount / responseRoom.quantity

                    room.daily_price[dayPriceIndex].percent_discount = null

                    // Cập nhật discount_reason với tên promotion hoặc voucher
                    if (this.selectedPromotion && this.selectedPromotion.name) {
                      room.daily_price[dayPriceIndex].discount_reason =
                        `Promotion: ${this.selectedPromotion.name}`
                    } else if (this.additionalInfoFormData.voucher_codes && this.additionalInfoFormData.voucher_codes.length > 0) {
                      const validVouchers = this.additionalInfoFormData.voucher_codes
                        .filter(v => v.status === 'valid')
                        .map(v => v.name || v.code)
                      if (validVouchers.length > 0) {
                        room.daily_price[dayPriceIndex].discount_reason =
                          `Voucher: ${validVouchers.join(', ')}`
                      }
                    }
                  }
                } else if (responseRoom.discount_percent !== null || responseRoom.discount_percent !== undefined) {
                  if (responseRoom.discount_percent === 0) {
                    room.daily_price[dayPriceIndex].amount_discount = null
                    room.daily_price[dayPriceIndex].percent_discount = null
                    room.daily_price[dayPriceIndex].discount_reason = null
                  } else {
                    // Nếu có discount_percent, cập nhật thông tin
                    room.daily_price[dayPriceIndex].percent_discount =
                      responseRoom.discount_percent

                    room.daily_price[dayPriceIndex].amount_discount = null

                    if (this.selectedPromotion && this.selectedPromotion.name) {
                      room.daily_price[dayPriceIndex].discount_reason =
                        `Promotion: ${this.selectedPromotion.name}`
                    } else if (this.additionalInfoFormData.voucher_codes && this.additionalInfoFormData.voucher_codes.length > 0) {
                      const validVouchers = this.additionalInfoFormData.voucher_codes
                        .filter(v => v.status === 'valid')
                        .map(v => v.name || v.code)
                      if (validVouchers.length > 0) {
                        room.daily_price[dayPriceIndex].discount_reason =
                          `Voucher: ${validVouchers.join(', ')}`
                      }
                    }
                  }
                }

                if (
                  responseRoom.final_price !== null &&
                  responseRoom.final_price !== undefined
                ) {
                  // Có thể lưu final_price vào một field khác hoặc tính toán lại
                  // room.daily_price[dayPriceIndex].final_price = responseRoom.final_price
                }

                if (
                  responseRoom.quantity !== null &&
                  responseRoom.quantity !== undefined
                ) {
                  // Có thể cập nhật quantity nếu cần
                  // room.daily_price[dayPriceIndex].quantity = responseRoom.quantity
                }
              }
            }
          }
        })
      })

      // Refresh table để hiển thị giá mới
      this.$nextTick(() => {
        if (
          this.$refs.BookingFormRoomTable?.$refs?.bookingRoomTable?.gridOptions
            ?.api
        ) {
          this.$refs.BookingFormRoomTable.$refs.bookingRoomTable.gridOptions.api.refreshCells(
            {
              force: true
            }
          )
        }

        // Reset flag sau khi cập nhật xong
        this.isUpdatingFromPromotion = false
      })
    },

    hasBookingRoomStructuralChange(newVal, oldVal) {
      // Kiểm tra thay đổi cấu trúc phòng (thêm/xóa phòng, thay đổi ngày, loại phòng)
      if (!oldVal || !newVal) return true
      if (newVal.length !== oldVal.length) return true

      // Kiểm tra từng phòng
      for (let i = 0; i < newVal.length; i++) {
        const newRoom = newVal[i]
        const oldRoom = oldVal[i]

        if (!oldRoom) return true

        // Kiểm tra các field quan trọng
        if (
          newRoom.room_type_id !== oldRoom.room_type_id ||
          newRoom.arrive_date !== oldRoom.arrive_date ||
          newRoom.depart_date !== oldRoom.depart_date ||
          newRoom.num_of_guest !== oldRoom.num_of_guest
        ) {
          return true
        }
      }

      return false
    },

    updateRoomPricesAfterVoucherRemoval() {
      // Cập nhật lại giá phòng sau khi xóa voucher
      this.formData.booking_room.forEach(room => {
        if (room.daily_price && room.daily_price.length > 0) {
          room.daily_price.forEach(day => {
            // Nếu không còn voucher nào hoặc voucher không hợp lệ, xóa giảm giá
            const hasValidVouchers = this.additionalInfoFormData.voucher_codes &&
              this.additionalInfoFormData.voucher_codes.some(v => v.status === 'valid')

            if (!hasValidVouchers) {
              // Xóa giảm giá từ voucher
              day.amount_discount = null
              day.percent_discount = null
              day.discount_reason = null
            } else {
              // Nếu còn voucher hợp lệ, cập nhật lại discount_reason
              const validVouchers = this.additionalInfoFormData.voucher_codes
                .filter(v => v.status === 'valid')
                .map(v => v.name || v.code)
              if (validVouchers.length > 0) {
                day.discount_reason = `Voucher: ${validVouchers.join(', ')}`
              }
            }
          })
        }
      })

      // Refresh UI với multiple approaches để đảm bảo cập nhật
      this.$nextTick(() => {
        // Refresh booking room table
        if (this.$refs.BookingFormRoomTable?.$refs?.bookingRoomTable?.gridOptions?.api) {
          this.$refs.BookingFormRoomTable.$refs.bookingRoomTable.gridOptions.api.refreshCells({
            force: true
          })
        }

        // Force update component để đảm bảo voucher tags được cập nhật
        this.$forceUpdate()
      })
    },

    updateRoomPricesAfterPromotionRemoval() {
      // Cập nhật lại giá phòng sau khi bỏ promotion
      this.formData.booking_room.forEach(room => {
        if (room.daily_price && room.daily_price.length > 0) {
          room.daily_price.forEach(day => {
            // Kiểm tra xem discount_reason có chứa "Promotion:" không
            if (day.discount_reason && day.discount_reason.includes('Promotion:')) {
              // Xóa giảm giá từ promotion
              day.amount_discount = null
              day.percent_discount = null
              day.discount_reason = null
            }
          })
        }
      })

      // Refresh UI với multiple approaches để đảm bảo cập nhật
      this.$nextTick(() => {
        // Refresh booking room table
        if (this.$refs.BookingFormRoomTable?.$refs?.bookingRoomTable?.gridOptions?.api) {
          this.$refs.BookingFormRoomTable.$refs.bookingRoomTable.gridOptions.api.refreshCells({
            force: true
          })
        }

        // Force update component để đảm bảo UI được cập nhật
        this.$forceUpdate()
      })
    }
  }
}
</script>

<style>
.promotion-display {
  margin-top: 8px;
  padding: 8px;
  background-color: #f0f9ff;
  border: 1px solid #b3d8ff;
  border-radius: 4px;
  font-size: 12px;
}

.voucher-tags-container {
  margin-top: 8px;
  padding: 8px;
  background-color: #f0f9eb;
  border: 1px solid #e1f3d8;
  border-radius: 4px;
}

.voucher-tags-title {
  font-weight: bold;
  margin-bottom: 4px;
  font-size: 12px;
  color: #52c41a;
}

.voucher-tags .el-tag {
  margin-right: 8px;
  margin-bottom: 8px;
}

.voucher-tags .el-tag:last-child {
  margin-right: 0;
}

/* Voucher tag chưa được kiểm tra - màu xám */
.voucher-tag--unchecked {
  font-weight: bold;
  background-color: #f5f5f5;
  border: 1px solid #d9d9d9;
  color: #666666;
}

/* Voucher tag hợp lệ (voucher_applied) - màu xanh lá */
.voucher-tag--valid {
  font-weight: bold;
  background-color: #f6ffed;
  border: 1px solid #52c41a;
  color: #52c41a;
}

/* Voucher tag không hợp lệ (voucher_not_valid) - màu đỏ */
.voucher-tag--invalid {
  font-weight: bold;
  background-color: #fff2f0;
  border: 1px solid #ff4d4f;
  color: #ff4d4f;
}
</style>
